var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#FDE0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_648_51010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 19.333C15.035 19.333 15.3335 19.6315 15.3335 19.9997C15.3335 20.3679 15.035 20.6664 14.6668 20.6664H8.00016C7.63197 20.6664 7.3335 20.3679 7.3335 19.9997C7.3335 19.6315 7.63197 19.333 8.00016 19.333H14.6668ZM15.4525 6.72892C15.6025 6.57878 15.8459 6.57873 15.996 6.72883L20.6382 11.3711C20.7881 11.5209 20.7882 11.7639 20.6384 11.9138L20.2302 12.3226C20.0688 12.4842 19.8299 12.5406 19.6132 12.4683C19.3968 12.396 19.1582 12.4522 18.9968 12.6134L17.6088 13.9997L20.9088 17.2997C21.1691 17.56 21.1691 17.982 20.9089 18.2423C20.6485 18.5027 20.2265 18.5026 19.9662 18.2423L16.6668 14.9424L15.3391 16.2701C15.1685 16.4407 15.1 16.6882 15.1585 16.9223C15.217 17.1564 15.1484 17.4041 14.9776 17.5747L14.5983 17.9538C14.4388 18.1132 14.1803 18.1131 14.0208 17.9537L9.41325 13.3461C9.25361 13.1865 9.25366 12.9276 9.41336 12.768L9.79293 12.3887C9.96329 12.2185 10.2104 12.15 10.4441 12.2083C10.6778 12.2667 10.925 12.1982 11.0954 12.0278L14.7534 8.37041C14.9149 8.20899 14.9713 7.97022 14.8991 7.75361C14.827 7.5371 14.8834 7.29842 15.0447 7.137L15.4525 6.72892ZM16.9026 9.52162C16.5121 9.13102 15.8789 9.13095 15.4883 9.52147L12.1886 12.8207C11.7981 13.2112 11.798 13.8443 12.1885 14.2349L13.1311 15.1778C13.5216 15.5684 14.1548 15.5684 14.5454 15.1779L17.8451 11.8787C18.2356 11.4882 18.2357 10.8551 17.8452 10.4645L16.9026 9.52162Z",
    fill: "url(#paint0_linear_648_51010)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_648_51010",
    x: 5,
    y: 5,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_648_51010"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_648_51010",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_648_51010",
    x1: 7.3335,
    y1: 6.45703,
    x2: 21.6201,
    y2: 6.70256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/Auction.ad5ab1602cc29e7e0d471e3928b1582e.svg";
export { ForwardRef as ReactComponent };